import { getEnvironment } from '@/config/runtime'
import { getTemplateTemplateScaffoldStyles } from './AuditManager.styles'
import type {} from './types/AuditManager.type'
import { tryLoadLightDOMStyles } from '../Global/loadDependency'

const t = document.createElement('template')
t.innerHTML = `
  <!-- Audit Manager -->
`
const TemplateAuditManager = t

class AuditManager extends HTMLElement {
  constructor() {
    super()

    const shadow = this.attachShadow({ mode: 'open' })
    shadow.appendChild(getTemplateTemplateScaffoldStyles().content.cloneNode(true))
    shadow.appendChild(TemplateAuditManager.content.cloneNode(true))

    tryLoadLightDOMStyles('AuditManager.css')
  }

  private loadJavaScriptModuleAudit(): Promise<void> {
    return new Promise((resolve, reject) => {
      const domain = this.getDomain()
      const src = `${domain}/storybook-internal/generated/internal-designsystem-audit.js`
      if (document.querySelector(`script[src="${src}"]`)) {
        resolve() // Script already exists, resolve immediately
        return
      }

      const script = document.createElement('script')
      script.type = 'module'
      script.src = src
      script.onload = () => resolve()
      script.onerror = () => reject(new Error(`Failed to load script: ${src}`))
      document.head.appendChild(script)
    })
  }

  private loadJavaScriptModuleDocs(): Promise<void> {
    return new Promise((resolve, reject) => {
      const domain = this.getDomain()
      const src = `${domain}/storybook-internal/generated/internal-designsystem-docs.js`
      if (document.querySelector(`script[src="${src}"]`)) {
        resolve() // Script already exists, resolve immediately
        return
      }

      const script = document.createElement('script')
      script.type = 'module'
      script.src = src
      script.onload = () => resolve()
      script.onerror = () => reject(new Error(`Failed to load script: ${src}`))
      document.head.appendChild(script)
    })
  }

  private getDomain(): string {
    const { environment } = getEnvironment()
    return environment === 'development' ? '' : 'https://backpack-storybook.trustagedemo.com/lts'
  }

  connectedCallback() {
    document.AscendAwesome?.LogManager?.logDebug('AuditManager connectedCallback')

    this.loadJavaScriptModuleAudit()
      .then(() => {
        document.AscendAwesome?.LogManager?.logDebug('AuditManager module loaded successfully')
        window.AscendAwesome?.Auditor?.addAuditUI()
      })
      .catch((err) => {
        document.AscendAwesome?.LogManager?.logError('Error loading AuditManager module', err)
      })

    this.loadJavaScriptModuleDocs().catch((err) => {
      document.AscendAwesome?.LogManager?.logError('Error loading Docs module', err)
    })
  }
}

if (!customElements.get('ts-auditmanager')) {
  customElements.define('ts-auditmanager', AuditManager)
}
export { AuditManager }
